import axios from "axios";
import {
  CreativeSizeOption,
  RaiseNoticeAdRequestWorkflowStep,
  RaiseNoticeRequestStep,
  RequestTypeOption,
} from "./type";
import { fileUploader, uploadToS3 } from "../../store/actions";
import { getConfig } from "../AgencyFileDrop/utils";
import { v4 } from "uuid";
import {
  patchAgencyQuotesAction,
  sendEmailAction,
  setUploadedFile,
  updateLastStepKey,
  uploadingFileLoaderAction,
  uploadRequestFile,
} from "../../store/actions/raiseAdRequest";
import { DESIGN_URI } from "../../utilities/paths";

export const raiseNoticeAdRequestWorkflow: RaiseNoticeAdRequestWorkflowStep[] = [
  {
    title: "Quotation & Approval",
    description:
      "Receive instant notifications on multiple channels like email and Slack, when campaigns meet specific conditions or thresholds",
  },
  {
    title: "Agency Quote Details",
    description:
      "Create sophisticated automation workflows with multiple conditions to fine-tune your marketing strategies",
  },
  {
    title: "Marketing Approval",
    description:
      "Set up custom rules to automatically adjust bids, budgets, and ads based on real-time performance metrics",
  },
  {
    title: "Ad Release",
    description:
      "Manage and automate your marketing efforts across all platforms from one centralized dashboard",
  },
  {
    title: "Final Market go Live",
    description:
      "Receive instant notifications on multiple channels like email and Slack, when campaigns meet specific conditions or thresholds",
  },
  {
    title: "Upload Proof",
    description:
      "Set up custom rules to automatically adjust bids, budgets, and ads based on real-time performance metrics",
  },
  {
    title: "Review and close",
    description:
      "Create sophisticated automation workflows with multiple conditions to fine-tune your marketing strategies",
  },
];

export const browseTemplatesUrls = {
  "5fb7860ad9ab530008fe692f":
    "https://aiquire-creative-dev.pyxispm.com#/cocreate/public/project/2e126c2dec43400ba0fefea84f80bf3d",
  "68bfba40df3c14d5ece9d906":
    "https://aiquire-creative-staging.pyxispm.com#/cocreate/public/project/89d8818d1b344a7f8298cfe603bfecea",
  "68d120998a83985a8649bee6":
    "https://app.pyxiscocreate.com#/cocreate/public/project/876351822cef401ba556c138f9bdf6ec",
  "68d294c742e6bbc0887e2549":
    "https://app.pyxiscocreate.com#/cocreate/public/project/c768344c6a7e44b4848b5023fce98d4c",
};

export const raiseNoticeRequestSteps: RaiseNoticeRequestStep[] = [
    {
    stepNumber: "1",
    name: "Request Creation",
    stepKey: "request-creation",
    isDisabled: false,
    isCurrentlyActive: false,
    permittedRoles: ["admin", "only-approver", "product-admin"],
    allowedRoles: "Regional Marketing Team",
  },
  {
    stepNumber:"1b",
    name: "Quotation & Approval",
    stepKey: "quotation-approval",
    isDisabled: true,
    isCurrentlyActive: false,
    permittedRoles: ["admin", "only-approver", "product-admin"],
    allowedRoles: "Media Marketing Team",
  },
  {
    stepNumber: "2",
    name: "Agency Quote Details",
    stepKey: "agency-quote-details",
    isDisabled: true,
    isCurrentlyActive: false,
    permittedRoles: ["admin", "designer-own-access", "product-admin"],
    allowedRoles: "Agency",
  },
  {
    stepNumber: "3",
    name: "Marketing Approvals",
    stepKey: "marketing-approval",
    isDisabled: true,
    isCurrentlyActive: false,
    permittedRoles: ["admin", "product-admin"],
    allowedRoles: "Media Marketing Team",
  },
  {
    stepNumber: "4",
    name: "Ad Release",
    stepKey: "ad-release",
    isDisabled: true,
    isCurrentlyActive: false,
    permittedRoles: ["admin", "only-approver", "product-admin"],
    allowedRoles: "Regional Marketing Team",
  },
  {
    stepNumber: "5",
    name: "Final Market go Live",
    stepKey: "final-market-live",
    isDisabled: true,
    isCurrentlyActive: false,
    permittedRoles: ["admin", "product-admin"],
    allowedRoles: "Media Marketing Team",
  },
  {
    stepNumber: "6",
    name: "Upload Proof",
    stepKey: "upload-proof",
    isDisabled: true,
    isCurrentlyActive: false,
    permittedRoles: ["admin", "designer-own-access", "product-admin"],
    allowedRoles: "Agency",
  },
  {
    stepNumber: "7",
    name: "Review and Close",
    stepKey: "review-and-close",
    isDisabled: true,
    isCurrentlyActive: false,
    permittedRoles: ["admin", "product-admin"],
    allowedRoles: "Media Marketing Team",
  },
];

export const StepKeysName = {
  RequestCreation: "request-creation",
  QuotationAndApproval: "quotation-approval",
  AgencyQuoteDetails: "agency-quote-details",
  MarketingApprovals: "marketing-approval",
  AdRelease: "ad-release",
  FinalMarketGoLive: "final-market-live",
  UploadProof: "upload-proof",
  ReviewAndClose: "review-and-close",
};

export const updateStepsWithLastStep = (
  lastStepName: string,
  currentStepKey: string,
  userRole: string
): RaiseNoticeRequestStep[] => {
  const lastIndex = raiseNoticeRequestSteps.findIndex(
    (step) => step.name === lastStepName
  );

  if (lastIndex === -1) return raiseNoticeRequestSteps;

  return raiseNoticeRequestSteps.map((step, index) => {
    const isRolePermitted = step.permittedRoles?.includes(userRole);

    return {
      ...step,
      isDisabled:
        index <= lastIndex && isRolePermitted ? false : step.isDisabled,
      isCurrentlyActive: step.stepKey === currentStepKey,
    };
  });
};


export const requestTypeOptions: RequestTypeOption[] = [
  { value: "branch-relocation", label: "Branch Relocation" },
  { value: "locker-break-in", label: "Locker Break-in" },
  { value: "other", label: "Other" },
];

export const creativeSizeOptions: CreativeSizeOption[] = [
  { value: "5x4", label: "5 x 4 cm" },
  { value: "other", label: "Other" },
];

export const NoticeRequesTypeNames = {
  BranchRelocation: "Branch Relocation",
  LockerBreakIn: "Locker Break-in",
  Other: "Other",
};

export const StepNames = [
  "Request Creation",
  "Quotation & Approval",
  "Agency Quote Details",
  "Marketing Approvals",
  "Ad Release",
  "Final Market go Live",
  "Upload Proof",
  "Review and Close",
];

export const handleUploadNoticeFiles = (
  fileList: any[],
  dispatch: any,
  request_id: string,
  stage: string,
  file_category: string,
  next_stage: string,
  selectedProductId: string,
  shouldSendMail?: boolean,
  formData?: any,
  template_id?: string,
  emailStage?: string,
  release_date?: string,
  extraFileUrls?: any[],
) => {
  let uploadedFileCount = 0;
  let file_urls = [];
  if (
    (fileList.length === 1 &&
      !!fileList[0]?.download_url &&
      file_category !== "Upload Proof") ||
    (file_category === "Upload Proof" && !fileList.length)
  ) {
    dispatch(
      patchAgencyQuotesAction({
        status: "Accepted",
        stage,
        workspaceId: selectedProductId,
        id: request_id,
        nextStepKey: next_stage,
      })
    );
    return;
  }
  if (!fileList.length) {
    dispatch(updateLastStepKey(stage));
    const urlFormed = `#/cocreate/workflow/raise-notice-ad/${selectedProductId}/${next_stage}/${request_id}`;
    window.location.assign(urlFormed);
    return;
  }
  dispatch(uploadingFileLoaderAction(true));
  fileList.forEach((file: any, index: number) => {
    // Skip API call if file is cancelled (only in upload list)
    if (file.status === "CANCELLED") {
      console.log(`File ${file.name} upload cancelled.`);
      return;
    }

    const config: any = getConfig(file, index);

    // Token to cancel API once it is called
    let fileToProjectToken = axios.CancelToken.source();
    file.token = fileToProjectToken;

    // Give unique name to each file so it's not replaced by other file while we upload file to S3
    let extension: string = file.name.split(".").pop();
    let file_name =
      file.name.slice(0, file.name.lastIndexOf(extension) - 1) +
      v4() +
      "." +
      extension;
    const file_size = file.size;

    // Step 1: Call fileUploader API

    dispatch(
      fileUploader(
        {
          file_name,
          file_size,
          file,
          config,
          cancelToken: fileToProjectToken,
        },
        (fileUploaderRes: any, error: boolean) => {
          console.log("🚀 ~ handleUploadNoticeFiles ~ fileUploaderRes:", fileUploaderRes)
          if (error) {
            return;
          }

          // Step 2: Upload to S3
          dispatch(
            uploadToS3(
              {
                file_url: fileUploaderRes.uploadURL || fileUploaderRes.uploadUrl,
                file,
                cancelToken: fileToProjectToken,
              },
              (S3res: any, s3Error: boolean) => {
                if (s3Error) {
                  console.error("S3 upload failed:", S3res);
                  dispatch(uploadingFileLoaderAction(false));

                  return;
                } else {
                  let requiredPayload = {
                    request_id,
                    stage,
                    file: fileUploaderRes.file_path,
                    original_filename: file_name,
                    title: file.name.slice(
                      0,
                      file.name.lastIndexOf(extension) - 1
                    ),
                    file_size: file_size,
                    file_category,
                    file_type: extension,
                    next_stage,
                    selectedProductId,
                  };
                  if (!!release_date) {
                    (requiredPayload as any).release_date = release_date;
                  }
                  dispatch(
                    uploadRequestFile(
                      requiredPayload,
                      (
                        requestFIleUploadRes: any,
                        requestFIleUploadError: boolean
                      ) => {
                        if (!!requestFIleUploadError) {
                          dispatch(uploadingFileLoaderAction(false));

                          return;
                        } else {
                          uploadedFileCount++;
                          file_urls.push(requestFIleUploadRes.file_url);
                          if (uploadedFileCount === fileList.length) {
                            if (!!shouldSendMail) {
                              dispatch(
                                sendEmailAction({
                                  formData,
                                  template_id,
                                  stage: emailStage,
                                  s3_urls: [...extraFileUrls, file_urls],
                                })
                              );
                            }
                            dispatch(uploadingFileLoaderAction(false));
                            dispatch(updateLastStepKey(stage));
                            const urlFormed = `#/cocreate/workflow/raise-notice-ad/${selectedProductId}/${next_stage}/${request_id}`;
                            window.location.assign(urlFormed);
                          }
                        }

                        // Step 3: Final action after S3 upload
                      }
                    )
                  );
                }

                // Step 3: Final action after S3 upload
              }
            )
          );
        }
      )
    );
  });
};

export const canPerformAction = (
  userRole: string,
  permittedRoles: string[],
  currentStepName: string,
  lastStepName: string,
  trashed_at: string
): boolean => {
  const isRolePermitted = permittedRoles.includes(userRole);
  const isCancelled = !!trashed_at;

  const currentIndex = StepNames.indexOf(currentStepName);
  const lastIndex = StepNames.indexOf(lastStepName);
  const isStepInRange =
    currentIndex !== -1 && lastIndex !== -1 && currentIndex <= lastIndex;

  // ✅ Compare all conditions together
  return isRolePermitted && !isCancelled && isStepInRange;
};

export const handleRequestDownload = async (id, token) => {
  const requestIds = Array.isArray(id) ? id : [id];
  // setIsDownloading(true)
  // dispatch(startRequestLoadingAction())
  try {
    const query = requestIds.map((id) => `request_ids=${id}`).join("&");
    const response = await fetch(
      `${DESIGN_URI}/api/notice-request-files/bulk-download/?${query}`,
      {
        method: "GET",
        headers: {
          token: token,
        },
      }
    );

    if (response.ok) {
      // Get the filename from response headers or use a default
      const contentDisposition = response.headers.get("content-disposition");
      let filename = "download.zip";
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
        if (filenameMatch) {
          filename = filenameMatch[1];
        }
      }

      // Create blob and download
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } else {
      console.error("Download failed:", response.statusText);
      alert("Download failed. Please check the console for details.");
    }
  } catch (error) {
    console.error("Download error:", error);
    alert("Download failed. Please check the console for details.");
  } finally {
    // setIsDownloading(false)
    // dispatch(stopLoadingOnErrorAction())
  }
};

export const isStepInRange = (currentStepName, lastStepName) => {
  const currentIndex = StepNames.indexOf(currentStepName);
  const lastIndex = StepNames.indexOf(lastStepName);
  const isStepExist =
    currentIndex !== -1 && lastIndex !== -1 && currentIndex <= lastIndex;
  return isStepExist;
};

export const noticeAdsSupportedFiles = {
  emails: [".eml,.pdf,.msg"]
}